import PropTypes from 'prop-types';
import { Fragment, memo, createElement as rc } from 'react';
import { Route } from 'react-router';
import { useTheme } from 'styled-components';
import RouteContainer from '../../RouteContainer';
import LayoutTitle from './LayoutTitle';
import doChildrenRequireSidebar from './doChildrenRequireSidebar';
// const themedLogos = require('../themedLogos');
// const { whiteLogo, colorLogo } = themedLogos;
import { fromTheme, styled, ThemeComponentSwitcher, View } from 'lib_ui-primitives';
import { metadata } from 'lib_ui-services';
import HNode from '../../../HNode';
import ContinuousScanPage from '../../ContinuousScanPage';
import ActiveRecord from '../../contextProviders/ActiveRecord';
import SyncDialog from '../../dialog/SyncDialog';
import NotificationIcon from '../../notification/NotificationIcon';
import NavbarContextProvider from '../NavbarContextProvider';
import Header from './Header';
import MainContainer from './MainContainer';

import Gl2025LeftSideNavAppLayout from './index.gl2025';

Header.displayName = 'LeftSideNavAppLayoutHeader';
const RightHeader = styled(View).attrs({ name: 'right-header' })`
    flex-basis: auto;
    flex-direction: row;
    align-items: center;
    margin-right: ${fromTheme('titleBar', 'marginRight')};
`;
const TitleHeader = styled(View).attrs({ name: 'title-header' })`
    flex-basis: auto;
    flex-direction: row;
    align-items: center;
    margin-left: ${fromTheme('titleBar', 'marginLeft')};
    margin-right: ${fromTheme('titleBar', 'marginRight')};
    padding: 0 ${fromTheme('titleBar', 'paddingHorizontal')};
`;

function LeftSideNavAppLayout(props) {
    const topMenuHNodes = metadata.getTopMenu();
    const { id, hNode, currentRoute, _excludeSideBar = false } = props;
    const excludeSideBar = _excludeSideBar || !doChildrenRequireSidebar(hNode.children?.[0]);
    const theme = useTheme();
    const headerButtonSize = theme?.titleBar?.buttonSize;

    //HACK, MDC3.0 needs to be updated to properly manage a splash page.
    //Right now, it relies on a top-level menu entry/page with the title "SPLASH", "somewhere" in the menu list
    //Ideally it should get it's own place slightly apart in the menu, or better yet, on a page of it's own.
    const splashScreenIndex = hNode.children[0]?.children?.findIndex(child => child.title === 'SPLASH');
    if (splashScreenIndex > -1) {
        const splashPageNavHeading = hNode.children[0].children[splashScreenIndex];
        const otherChildren = hNode.children[0].children.filter((_, i) => i !== splashScreenIndex);

        const splashNode = {
            hNodeType: 'SplashContextAppLayout',
            hNodeTypeGroup: 'appLayout',
            namespace: splashPageNavHeading.children?.[0]?.defaultNamespace || 'metadata',
            relation: splashPageNavHeading.children?.[0]?.defaultRelation || 'useCaseDetail',
            splashPage: splashPageNavHeading,
            children: [{ ...hNode, children: [{ ...hNode.children[0], children: otherChildren }] }]
        };
        return rc(HNode, { ...props, hNode: splashNode, children: undefined });
    }

    // prettier-ignore
    return rc(NavbarContextProvider, null,
        //topBar
        rc(Header, null,
            rc(TitleHeader, null,
                rc(LayoutTitle)
            ),
            rc(RightHeader, null,
                rc(NotificationIcon, { id:`notif${id}`, size: headerButtonSize }),
                rc(ActiveRecord, {namespace: 'security',relation: 'profile'},
                    topMenuHNodes.map(topMenuHNode =>
                        rc(HNode, { hNode: { showDarkModeToggle: true, buttonSize: headerButtonSize, ...topMenuHNode }, key:topMenuHNode.id, currentRoute })
                    )
                ),
                rc(SyncDialog, { id:`sync${id}`, size: headerButtonSize })
            )
        ),
        // Sidebar (nav_SideNav) with NavHeaders
        !excludeSideBar && rc(Fragment, null, props.children),

        //main content
        rc(MainContainer, {excludeSideBar},
            rc(Route, { path: ['/continuous-scan', '/g/:groupNumber/continuous-scan'] },
                rc(View, { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1, elevation: 1 } },
                    rc(ContinuousScanPage)
                )
            ),
            rc(RouteContainer, { hNode, currentRoute })
        )
    );
}

LeftSideNavAppLayout.propTypes = {
    children: PropTypes.array,
    hNode: PropTypes.object,
    skipSideBar: PropTypes.bool
};
let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: Gl2025LeftSideNavAppLayout
    },
    { component: memo(LeftSideNavAppLayout) }
]);

export default SwitchedComponent;
